import { render, staticRenderFns } from "./WarehouseList.vue?vue&type=template&id=540edd92&scoped=true"
import script from "./WarehouseList.vue?vue&type=script&lang=js"
export * from "./WarehouseList.vue?vue&type=script&lang=js"
import style0 from "./WarehouseList.vue?vue&type=style&index=0&id=540edd92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540edd92",
  null
  
)

export default component.exports